var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 10,
    fill: "#D1FE17",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 9.5,
    stroke: "#D1FE17",
    strokeOpacity: 0.1,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9992 6C12.0634 5.9999 12.1267 6.01574 12.1841 6.04627C12.2414 6.07679 12.2912 6.12112 12.3293 6.1757L15.9885 11.4243L11.9992 12.823L8.00983 11.4243L11.6707 6.1757C11.7087 6.12136 11.7582 6.07717 11.8152 6.04665C11.8722 6.01614 11.9352 6.00017 11.9992 6ZM8.00082 12.5598L11.6707 17.824C11.7088 17.8786 11.7584 17.9229 11.8157 17.9535C11.873 17.9841 11.9362 18 12.0004 18C12.0646 18 12.1278 17.9841 12.1851 17.9535C12.2424 17.9229 12.2921 17.8786 12.3301 17.824L16 12.5598L12.1622 13.9066C12.0574 13.9431 11.9443 13.9431 11.8394 13.9066L8.00082 12.5598Z",
    fill: "#D1FE17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEthereum);
export default __webpack_public_path__ + "static/media/icon_ethereum.591ef1729e9979441fe5393f6636cfde.svg";
export { ForwardRef as ReactComponent };